import axiosClient from "config/axios";
/***
 * get videos from backend
 */
export const getVideos = async (data) => {
  let result = {};
  await axiosClient
    .get("/resources/video/", data)
    .then((response) => {
      result = {
        error: false,
        result: response.data,
      };
    })
    .catch((error) => {
      result = {
        error: true,
        message: "auth__server_error",
      };
    });
  return result;
};
